module.exports = __webpack_public_path__ + "static/img/pa-keystone-large.32f26b39.png";